import React from 'react'
import { Col, Row } from 'react-flexbox-grid'
import { useTranslation } from 'react-i18next'
import moment from 'moment'
import get from 'lodash/get'
import 'moment/locale/fr'
import 'moment/locale/it'

import { updateQuery } from 'components/graphql'
import Divider from 'components/Divider'
import { Form, Text, DateTimePicker, Select } from 'components/forms'
import { ContentBlock } from 'components/ContentBlock'
import CashRegisterTree from 'components/CashRegisterTree'
import { listHolidays } from './gql'
import { notEmpty } from 'helpers/validators'

const CashRegisters = ({ data, mutations: { updateItem }, listQueryRef: { current } }) => {
	const [t, i18n] = useTranslation()

	const selectOptions = () => {
		const optionsArr = []
		let lang = ''

		switch(i18n.language) {
			case 'German':
				lang = 'de'
				break
			case 'English':
				lang = 'en'
				break
			case 'French':
				lang = 'fr'
				break
			case 'Italian':
				lang = 'it'
				break
			default:
				return
		}

		for (let index = 1; index < 8; index++) {
			const weekDayVal = moment().day(index).locale('en').format('dddd').toUpperCase()
			const weekDayLabel = moment().day(index).locale(lang).format('dddd').toUpperCase()
			optionsArr.push({ value: weekDayVal, label: weekDayLabel })
		}
		return optionsArr
	}

	const handleFormChange = ({ date, name, day, ...restVals }) => {
		const formatDate = moment(date).format('YYYY-MM-DD')
		const update = updateQuery({ query: listHolidays, variables: current?.variables }, (draft, { mutationResult = {}, readQuery, queryField }) => {
			const mutatedId = get(mutationResult, 'id', '')
			const newLists = readQuery.items.map((item = {}) => mutatedId.toString() === item.id.toString() ? mutationResult : item)
			draft[queryField].items = newLists
		})
		const optimisticResponse = {
			__typename: 'Mutation',
			cashAssist: {
				__typename: 'CA_Mutation',
				updateFreeDay: {
					...data
				}
			}
		}
		updateItem({ ...restVals, date: formatDate, day, name }, { update, optimisticResponse })
	}

	return (
		<ContentBlock label={t('options_section.strings.public_holidays')}>
			<Form initialValues={{ ...data, date: moment(data.date).utc(data.date) }} onSubmit={handleFormChange} smartSubmit>
				<Row>
					<Col xs={2}>
						<DateTimePicker
							label={t('options_section.fields.date')}
							field='date'
							picker='date'
						/>
					</Col>
					<Col xs={3}>
						<Text field='name' label={t('options_section.fields.name')} {...notEmpty()} validateOnChange />
					</Col>
					<Col xs>
						<Select
							label={t('options_section.fields.day')}
							field='day'
							options={selectOptions()}
						/>
					</Col>
				</Row>
				<Divider visible/>
				<Row>
					<Col xs={12}>
						<CashRegisterTree
							activeNodesArr={data.cashRegisterId}
							onChange={cashRegisterId => updateItem({ cashRegisterId, date: data.date, day: data.day })}
							withContext
						/>
					</Col>
				</Row>
			</Form>
		</ContentBlock>
	)
}

export default CashRegisters
